module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"filterByLocation":"Location","filterByQuery":"Name, Adresse oder Auftragsnummer"},"de":{"filterByLocation":"Standort","filterByQuery":"Name, Adresse oder Auftragsnummer"},"fr":{"filterByLocation":"Emplacement","filterByQuery":"Nom, adresse ou numéro de commande"},"it":{"filterByLocation":"Locazione","filterByQuery":"Name, Adresse oder Auftragsnummer"}}')
  delete Component.options._Ctor
}
